import { render, staticRenderFns } from "./SpilloverPolicyDataTable.vue?vue&type=template&id=1fcdf52a&scoped=true"
import script from "./SpilloverPolicyDataTable.vue?vue&type=script&lang=js"
export * from "./SpilloverPolicyDataTable.vue?vue&type=script&lang=js"
import style0 from "./SpilloverPolicyDataTable.vue?vue&type=style&index=0&id=1fcdf52a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcdf52a",
  null
  
)

export default component.exports